import type { IDynamicFeedbackTargets } from '@common/interfaces/dynamicEnvFeedback'
import api from '../../api'
import { readStoredJson, writeStoredString } from '../../helpers/storedFlag'

// Each dynamic env is its own origin, so a stored list can only be this PR's.
const STORAGE_KEY = 'dynamicEnvFeedback.targets'

let request: Promise<IDynamicFeedbackTargets> | null = null

// The last list this browser saw, shown at once after a reload while a fresh one loads. A value
// of another shape (an older payload) is ignored rather than rendered.
export const readCachedTargets = (): IDynamicFeedbackTargets | null => {
  const stored = readStoredJson(STORAGE_KEY) as IDynamicFeedbackTargets | null
  return stored && Array.isArray(stored.targets) ? stored : null
}

// The env's PR and its tickets hold for the page's life: one request to prod, shared by every
// open. A failed one is forgotten, so the next open retries.
export const loadTargets = (): Promise<IDynamicFeedbackTargets> => {
  request ??= api.dynamicEnvFeedback.listTargets().then(
    (targets) => {
      writeStoredString(STORAGE_KEY, JSON.stringify(targets))
      return targets
    },
    (error: unknown) => {
      request = null
      throw error
    },
  )
  return request
}

// Asks prod again, for when a submit shows the list was out of date.
export const reloadTargets = (): Promise<IDynamicFeedbackTargets> => {
  request = null
  return loadTargets()
}
